import React from 'react';
import { MessageCircle } from 'lucide-react';
import { motion } from 'framer-motion';

const WhatsAppButton = () => {
  const phoneNumber = "919567810944";
  const message = "Hi, I'm interested in building a home in Kannur. Can we discuss?";
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <motion.a
      href={whatsappUrl}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 right-6 z-50 bg-green-500 hover:bg-green-600 text-white rounded-full p-4 shadow-2xl shadow-green-500/30 flex items-center justify-center transition-transform hover:scale-110"
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ type: "spring", stiffness: 260, damping: 20, delay: 1 }}
      aria-label="Chat with us on WhatsApp"
    >
      <MessageCircle size={32} />
      <span className="absolute -top-12 right-0 bg-white text-gray-800 text-sm font-bold py-2 px-4 rounded-xl shadow-lg border border-gray-100 whitespace-nowrap hidden md:block">
        Chat with a Builder 👋
        <div className="absolute -bottom-2 right-6 w-4 h-4 bg-white transform rotate-45 border-b border-r border-gray-100"></div>
      </span>
    </motion.a>
  );
};

export default WhatsAppButton;
